import { useUpdateUserSettings } from 'features/user';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { useUser } from 'shared/hooks/use-user';
import { LimitKeys } from 'shared/types/limit-keys';
import { UpcomingViewOptions } from 'shared/types/upcoming-view-options';
import { targetIsInput } from 'shared/utils/target-is-input';
import { useTheme } from 'styled-components';

export const useSelectedView = () => {
  const theme = useTheme();
  const user = useUser();

  const openPremiumDialog = useOpenPremiumDialog();
  const updateUserSettings = useUpdateUserSettings();

  const { allowed: isCalendarWeekAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarMonth,
    {},
  );
  const { allowed: isCalendarMonthAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarMonth,
    {},
  );

  const view =
    ((isCalendarMonthAllowed || isCalendarWeekAllowed) && !theme.isMobile
      ? user?.settings?.upcoming?.webView
      : undefined) ?? UpcomingViewOptions.List;

  const setView = (view: UpcomingViewOptions) => {
    if (
      view === UpcomingViewOptions.Calendar &&
      !(isCalendarMonthAllowed || isCalendarWeekAllowed)
    ) {
      openPremiumDialog();
      return;
    }

    updateUserSettings({ upcoming: { webView: view } });
  };

  useKeysDown(
    ['KeyL'],
    (e) => {
      if (targetIsInput(e.target)) {
        return; // Don't open dialog
      }
      setView(UpcomingViewOptions.List);
    },
    { otherKeysInCombinationAllowed: true },
  );

  useKeysDown(
    ['KeyC'],
    (e) => {
      if (targetIsInput(e.target)) {
        return; // Don't open dialog
      }
      setView(UpcomingViewOptions.Calendar);
    },
    { otherKeysInCombinationAllowed: true },
  );

  return {
    view,
    setView,
  };
};
